export const REVIEW_ACTION_TYPE = Object.freeze({
  ACCEPT: 'ACCEPTED',
  REJECT: 'REJECTED',
  PENDING: 'PENDING'
});
export type ReviewActionT = (typeof REVIEW_ACTION_TYPE)[keyof typeof REVIEW_ACTION_TYPE];